import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        alignSelf: "center",
        alignItems: "center"
    }
});

export default stylesheet;
